/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AccessKey/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromViewsValidate from 'Simple/Data/validate'
import React from 'react'
import TysiaInputWithLabelField from 'DesignSystem/TysiaInputWithLabelField/index'
import VisibilityAction from './VisibilityAction/index'



/** @type {import('Simple/types.js').View} */
export default function AccessKey({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/AddAction/Content/Content/Bluefin/AccessKey",
  onChange,
  isInvalid
  
}) {
  let flow = fromFlow.useFlow()
let addProviderBluefinAccessKeyValueData = fromData.useDataValue({ viewPath,
context: 'add_provider',
path: 'bluefin.access_key',
})
let addProviderBluefinAccessKeyIsValidData = fromData.useDataIsValid({ viewPath,
context: 'add_provider',
path: 'bluefin.access_key',
validate: fromViewsValidate.textAtLeastOneChar,
required: true,
})
let addProviderBluefinAccessKeyChangeData = fromData.useDataChange({ viewPath,
context: 'add_provider',
path: 'bluefin.access_key',
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<TysiaInputWithLabelField
  viewPath={`${viewPath}/TysiaInputWithLabelField`}
 marginTop={0}
 marginBottom={0}
 backgroundColor={dtColorsWhite}
 label="Access key"
 data="add_provider.bluefin.access_key"
 value={addProviderBluefinAccessKeyValueData}
 onChange={addProviderBluefinAccessKeyChangeData}
 required={true}
 validate="textAtLeastOneChar"
 invalid={!addProviderBluefinAccessKeyIsValidData}
 type={flow.has(fromFlow.normalizePath(viewPath, 'VisibilityAction/Show')) ? "text" : "password"}
/>
<VisibilityAction
  viewPath={`${viewPath}/VisibilityAction`}
/>
{children}
</React.Fragment>)
}